module.exports = __webpack_public_path__ + "web/img/ques_bg_lt.73f4797f.png";